module.exports = __webpack_public_path__ + "img/logo-dark.bf3960d9.svg";